import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useFormSubmit } from "./useFormSubmit";
import { useTransformValues } from "./useTransformValues";
import { useAdaptedUpdateFields } from "./useAdaptedUpdateFields";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";
import {fetchUpdateFields} from "../slices/getFieldUpdatesSlice";

export const useDeparturesReportUpdateForm = ({id}) => {
    const dispatch = useDispatch();
    const formId = "updateForm";
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);
    const reload = true;
    const { transformFormValues } = useTransformValues();

    useEffect(() => {
        dispatch(fetchUpdateFields({token}));
    }, [dispatch, token]);

    const adaptedFieldList = useAdaptedUpdateFields();
    const fields = adaptedFieldList.flatMap(category => category.fields);

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const attributes = transformFormValues(formValues, fields);

            const body = {
                data: {
                    type: "update",
                    attributes: attributes
                }
            };

            const action = await dispatch(sendForm({url: `/reports/update/${id}`, body, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    return { formId, loadingStatus, handleSend: handleSubmit, adaptedFieldList }
}